import { putAudience } from '../services';
export const saveAudience = (params) => putAudience(params).then(response => formatResponse(response?.data));
const formatResponse = (response) => {
    return {
        audienceId: response?.data?.id,
        success: response?.success,
    };
};
